import { render, staticRenderFns } from "./ScreenCardSkeletonLoader.vue?vue&type=template&id=fb062df6&scoped=true&"
import script from "./ScreenCardSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./ScreenCardSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./ScreenCardSkeletonLoader.vue?vue&type=style&index=0&id=fb062df6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb062df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VSkeletonLoader})
